import { watch, ref } from "vue";
import { useOrgInfoStore } from "~/stores/OrgInfoStore";

const CSS_ELEMENT_ID = "org-custom-css";

export function useOrgCSS() {
  const orgInfoStore = useOrgInfoStore();
  const isApplied = ref(false);

  const applyOrgCSS = () => {
    // Remove any existing custom CSS
    const existingStyle = document.getElementById(CSS_ELEMENT_ID);
    if (existingStyle) {
      existingStyle.remove();
      isApplied.value = false;
    }

    // Get the custom CSS from org info
    const customCSS = orgInfoStore.MyOrgInfo?.customCSS?.trim();

    if (customCSS) {
      // Create and inject the style element
      const styleElement = document.createElement("style");
      styleElement.id = CSS_ELEMENT_ID;
      styleElement.textContent = customCSS;

      // Add to document head
      document.head.appendChild(styleElement);
      isApplied.value = true;

      // console.log("Applied org-specific CSS");
    }
  };

  const removeOrgCSS = () => {
    const existingStyle = document.getElementById(CSS_ELEMENT_ID);
    if (existingStyle) {
      existingStyle.remove();
      isApplied.value = false;
      // console.log("Removed org-specific CSS");
    }
  };

  // Watch for changes in org info and apply CSS automatically
  watch(
    () => orgInfoStore.MyOrgInfo?.customCSS,
    () => {
      applyOrgCSS();
    },
    { immediate: true },
  );

  return {
    applyOrgCSS,
    removeOrgCSS,
    isApplied: isApplied.value,
  };
}
